import {
  GeoCellDisplayStatus,
  GeoTestStatus,
  ICPAdTestConfig
} from '@portal/app/geo-designer/models/ICPAdTestConfig';
import dayjs from 'dayjs';
import { getDateWithoutTimezoneConsideration } from '@portal/app/dashboard/geo-doe-config/shared/dateUtils';
import { RecommendationResult, Status } from '@libs/apis';
import { TestAlertsHelper } from '@portal/app/geo-designer/common/test-alerts.helper';

export class TestStatusHelper {
  public static getDisplayStatus = (
    geoTest: ICPAdTestConfig
  ): {
    actualStatus: GeoTestStatus;
    displayStatus: GeoCellDisplayStatus;
  } => {
    const { today, startDate, endDate, reportEndDate } =
      this.getFormattedTestDates(geoTest);

    if (geoTest.status === Status.ACTIVE) {
      if (today.isBefore(startDate)) {
        return {
          actualStatus: GeoTestStatus.scheduled,
          displayStatus: GeoCellDisplayStatus.scheduled
        };
      }

      if (!geoTest.studyState && geoTest.disableSync === 0) {
        return {
          actualStatus: GeoTestStatus.scheduled,
          displayStatus: GeoCellDisplayStatus.pendingToLaunch
        };
      }

      if (today.isAfter(startDate) && today.isBefore(endDate)) {
        return {
          actualStatus: GeoTestStatus.active,
          displayStatus: GeoCellDisplayStatus.inProgress
        };
      }

      if (today.isAfter(endDate) && today.isBefore(reportEndDate)) {
        return {
          actualStatus: GeoTestStatus.active,
          displayStatus: GeoCellDisplayStatus.resultsPending
        };
      }

      if (today.isAfter(endDate) && today.isAfter(reportEndDate)) {
        return {
          actualStatus: GeoTestStatus.finished,
          displayStatus: GeoCellDisplayStatus.finished
        };
      }
    } else if (geoTest.status === Status.DRAFT) {
      if (
        this.isActionNeeded(
          geoTest.recommendationResult as RecommendationResult
        ) ||
        today.isAfter(startDate)
      ) {
        return {
          actualStatus: GeoTestStatus.scheduled,
          displayStatus: GeoCellDisplayStatus.actionNeeded
        };
      } else if (today.isBefore(startDate)) {
        return {
          actualStatus: GeoTestStatus.scheduled,
          displayStatus: GeoCellDisplayStatus.draft
        };
      }
    }
    return {
      actualStatus: GeoTestStatus.active,
      displayStatus: GeoCellDisplayStatus.none
    };
  };

  private static getFormattedTestDates(geoTest: ICPAdTestConfig) {
    const today = dayjs();
    const startDate = getDateWithoutTimezoneConsideration(
      geoTest.startDate.toString().split('T')[0]
    );
    const endDate = getDateWithoutTimezoneConsideration(
      geoTest.endDate.toString().split('T')[0]
    );

    const reportEndDate = getDateWithoutTimezoneConsideration(
      geoTest.reportEndDate.toString().split('T')[0]
    );

    return { today, startDate, endDate, reportEndDate };
  }

  private static isActionNeeded = (
    recommendationResult: RecommendationResult
  ): boolean => {
    return (
      TestAlertsHelper.isTacticNotFound(recommendationResult) ||
      TestAlertsHelper.isMsExpired(recommendationResult) ||
      TestAlertsHelper.isWaitingForApproval(recommendationResult)
    );
  };
}
